import { render, staticRenderFns } from "./ToggleableText.vue?vue&type=template&id=2ef69375&scoped=true"
import script from "./ToggleableText.vue?vue&type=script&lang=ts"
export * from "./ToggleableText.vue?vue&type=script&lang=ts"
import style0 from "./ToggleableText.vue?vue&type=style&index=0&id=2ef69375&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef69375",
  null
  
)

export default component.exports